import React, { useContext } from 'react';
import { connect } from "react-redux";
import { UserContext } from "../../providers/user-provider";
import { compose } from 'redux';
import PropTypes from 'prop-types';
import AddAlbum from '../add-album/';
import AddFeature from '../add-feature/';
import ContentPage from '../content-page/';
import AlbumList from '../album-list/';
import FeatureList from '../feature-list/';
import AdminHome from '../admin-home';
import AdminNavigation from './admin-nav';
import ImpersonationUserStatus from '../impersonation-user-status';
import PasswordReset from './auth/password-reset';
import SignIn from './auth/signin';
import SignUp from './auth/signup';
import LoadingAnimation from '../loading-animation';
import Notifications from '../notifications/';
import UserInfo from './auth/user-info';
import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route
} from "react-router-dom";
import './admin.scss';


export const Admin = ({ impersonationUser, isAuthenticating }) => {
	const user = useContext(UserContext);
	const userRole = user && user.role
	const isAdminRole = (userRole === 'admin' ||  userRole === 'owner');
	const renderGate = () => {
		if (isAdminRole) {
			return (
				<Router>
					<div className={`admin-app${impersonationUser ? ' with-impersonation-status' : ''}`}>
						<div className="app-subheader admin-app-header">
							<div className="primary">
								<AdminNavigation />
							</div>
							<div className="secondary">
								<UserInfo />
							</div>
						</div>
						<ImpersonationUserStatus />
						<div className="app-body admin-app-body">
							<Notifications />
							<Switch>
								<Route path="/albums/:slug" component={AddAlbum}></Route>
								<Route path="/albums">
										<AlbumList />
								</Route>
								<Route path="/add-album">
									<AddAlbum />
								</Route>
								<Route path="/features/:slug" component={AddFeature}></Route>
								<Route path="/features">
										<FeatureList />
								</Route>
								<Route path="/add-feature">
									<AddFeature />
								</Route>
								{userRole === 'owner' &&
									<Route path="/about">
										<ContentPage id="about" title="About" />
									</Route>
								}
								<Route path="/add-review/" component={AddAlbum}></Route>
								<Route exact path="/" component={AdminHome}></Route>
								<Redirect to='/' />
							</Switch>
						</div>
					</div>
				</Router>
			);
		} else if (user) {
			return (
				<div className="admin-app">
					<div className="app-subheader admin-app-header">
						<div className="primary">
						</div>
						<div className="secondary">
							<UserInfo />
						</div>
					</div>
					<div className="app-body admin-auth-body">
						{ !isAdminRole ?
						<div className="auth-section">
							<div className="auth-heading">
								<h1>Not In My Palace.</h1>
							</div>
							<div className="auth-message-only">
								<p><span>Your account has been created. PMA Gunnerfeldt is personally reviewing your credentials to determine account permissions. Check back soon.</span></p>
							</div>
						</div> :
						<LoadingAnimation text="Loading User Permissions..." showMask/>
						}
					</div>
				</div>
			);
		} else {
      return (
				<div className="admin-app needs-auth">
					<div className="app-subheader admin-app-header"></div>
					<div className="app-body admin-auth-body">
						<Notifications />
						<div className="auth-section">
							<form>
							{ (isAuthenticating) && <LoadingAnimation text="Authenticating..." showMask /> }
							<Switch>
								<Route path="/signin" component={SignIn}></Route>
								<Route path="/password-reset" component={PasswordReset}></Route>
								<Route path="/signup" component={SignUp}></Route>
								<Route path="/" component={SignIn}></Route>
							</Switch>
							</form>
						</div>
					</div>
				</div>
			)
    }
	};

	return (
		<div className="body-wrap admin-wrap">
			{ renderGate() }
		</div>
	);
}

Admin.propTypes = {
	impersonationUser: PropTypes.object,
	isAuthenticating: PropTypes.bool
};

const mapStateToProps = state => {
  return {
		impersonationUser: state.impersonationUser,
		isAuthenticating: state.isAuthenticating
  }
}

const mapDispatchToProps = {};


export const AuthenticatedAdmin = compose(
	connect(mapStateToProps, mapDispatchToProps)
)(Admin);
